import { useState } from "react";
import AppDialog from "../../../components/Common/AppDialog";
import Label from "../../../components/Common/Label";
import Helpers from "../../../helpers/helpers";

export default function MoveToHidden({ open, close, handleSubmit, windowWidth, isBulkAction = false, selectedItems = [] }) {
    const [showAll, setShowAll] = useState(false);
    const itemsToShow = isBulkAction ? showAll ? selectedItems : selectedItems.slice(0, 2) : [];
    return (
        <AppDialog
            title={'Set as to Hidden'}
            open={open}
            close={close}
            positiveTitle={'Set as Hidden'}
            positivePress={() => handleSubmit()}
            cancelButton={true}
            width={'40%'}
            isMobile={windowWidth <= 768}
        >
            {
                isBulkAction ?
                    <>
                        <div>Are you sure you want to set {selectedItems.length} selected advert(s) as hidden? </div>
                        <ol style={{ paddingInline: 20, paddingBlock: 10 }}>
                            {itemsToShow?.map((item, idx) => (
                                <li key={idx} className="mb-2 ">
                                    <div className="d-flex align-items-center">
                                        {item?.make?.name || '-'} {item?.model?.model_name || ''}
                                        <Label.GeneralStatusLabel label={item?.status || '-'} list={Helpers.advertStatus} marginLeft={"10px"} />
                                    </div>
                                </li>
                            ))}
                            {selectedItems.length > 2 && (
                                <div
                                    onClick={() => setShowAll(!showAll)}
                                    className="clickable underline"
                                    style={{ marginTop: '10px' }}
                                >
                                    {showAll ? 'Show less' : 'Show more'}
                                </div>
                            )}
                        </ol>
                    </> :
                    <>
                        <div>Are you sure you want to move this advert to draft? </div>
                    </>
            }

            <div className="my-2">Once confirmed:</div>
            <ul className="subheader-2" style={{ padding: 5, paddingInline: 15 }}>
                <li className="mb-2">The advert will no longer appear on the marketplace.</li>
                <li className="mb-2">All current settings, images, and content will remain saved.</li>
                <li className="mb-2">You can edit and republish the advert later.</li>
            </ul>
        </AppDialog>
    )
}